const formatCurrentDateTime = (): string => {
  const options = {
    month: 'long' as const,
    day: 'numeric' as const,
    year: 'numeric' as const,
    hour: 'numeric' as const,
    minute: 'numeric' as const,
    hour12: true,
  };

  const currentDate = new Date();
  const formattedDateTime = currentDate.toLocaleString('en-US', options);

  return formattedDateTime;
};

export default formatCurrentDateTime;
